import {
  AUTHENTICATE,
  AUTHENTICATE_ERROR_AUTH,CLEAR_ALL
} from '../actions/authActions';

const initialState = {
  fullName: localStorage.getItem("username"),
  avatar: '',
  bearerToken:'',
  instId:'',
  role:'',
  roleId:''
};

const authReducer = (state = initialState, action) => { 
  switch (action.type) {
    case AUTHENTICATE:
      // return { fullName: action.user.name, avatar: action.user.avatar };
      return { fullName: action.user.name, avatar: action.user.avatar, bearerToken:action.user.bearerToken,instId:action.user.avatar,role:action.user.role,roleId:action.user.roleId };
      case AUTHENTICATE_ERROR_AUTH:
      return { error: action.error };
    case CLEAR_ALL:
      return  state = undefined; 
    default:
      return state;
  }
};

export default authReducer;
